import { logUsage } from 'owa-analytics';
import ClientTypeOptInState from 'owa-service/lib/contract/ClientTypeOptInState';
import updateClientTypeOptInStateOperation from 'owa-service/lib/operation/updateClientTypeOptInStateOperation';
import {
    isClientOptingReact,
    isClientOptingJsmvvm,
    updateClientOptInStateCookie,
} from '../utils/owaOptinUtility';

const MAX_RETRY_COUNT: number = 2;
const RETRY_TIMEOUT_MS: number = 10000;

let updateClientOptInRetryCount = 0;

export default function checkAndUpdateClientTypeOptInState(windowObj: Window) {
    if (isClientOptingReact()) {
        updateClientOptInStateCookie(ClientTypeOptInState.None);

        windowObj.addEventListener('unload', function() {
            if (!isClientOptingJsmvvm()) {
                updateClientOptInStateCookie(null);
            }
        });

        logUsage('optInReactClient');
        updateClientTypeOptinState(windowObj);
    }
}

function updateClientTypeOptinState(windowObj: Window) {
    const optInState: ClientTypeOptInState = ClientTypeOptInState.React;
    updateClientTypeOptInStateOperation({ clientTypeOptInState: optInState })
        .then((updated: Boolean) => {
            updateClientOptInStateCookie(null);
        })
        .catch((error: any) => {
            if (updateClientOptInRetryCount++ < MAX_RETRY_COUNT) {
                windowObj.setTimeout(() => {
                    updateClientTypeOptinState(windowObj);
                }, RETRY_TIMEOUT_MS);
            }
        });
}
